import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { environment } from '../../../environments/environment';
import { routerTransition } from '../../router.animations';

@Component({
  selector: 'app-gym',
  templateUrl: './gym.component.html',
  styleUrls: ['./gym.component.css'],
  animations: [routerTransition()],
  host: {'[@routerTransition]': ''}
})
export class GymComponent implements OnInit {
  gym: any;
  packageTypes: Array<any>;
  language: string;
  baseUrl: string = environment.baseUrl;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
        this.language = params.get('language');
    });
    this.route.data.subscribe(data => {
      this.gym = data.gym['gym'];
      if (this.gym.body) {
        this.gym.body = this.gym.body.replace(/\/cms/g, (this.baseUrl + '/cms'));
      }
      if (this.gym.field_gym_contact_us_text) {
        this.gym.field_gym_contact_us_text = this.gym.field_gym_contact_us_text.replace(/\/cms/g, (this.baseUrl + '/cms'));
      }
      if (data.gym.packageTypes) {
        this.packageTypes = data.gym.packageTypes;
        this.packageTypes.forEach((packageType, idx, arr) => {
          if (packageType.field_package_offer) {
            arr[idx].field_package_offer = packageType.field_package_offer.split(',');
          }
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/gym/gym.component.ts